import { render, staticRenderFns } from "./handleModal.vue?vue&type=template&id=4f1ed444"
import script from "./handleModal.vue?vue&type=script&lang=js"
export * from "./handleModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports